import { Typography } from "@mui/material";
import React from "react";

const NotFoundFilterView = () => {
  return <Typography sx={{ fontWeight: "bolde" }}>Không có kết quả thỏa mãn điều kiện tìm kiếm.</Typography>;
};

export default NotFoundFilterView;
